// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2ioKz{text-align:center}._1KFWl{margin:15px}._1-6nE{margin:5px}", ""]);
// Exports
exports.locals = {
	"plan": "_2ioKz",
	"price": "_1KFWl",
	"button": "_1-6nE"
};
module.exports = exports;
